export const buildEmployeeCycleProgressId = (
  employeeId?: string,
  cycleId?: string
): string | undefined => {
  if (!employeeId || !cycleId) return
  return `${employeeId}-${cycleId}`
}
